import React, { useState } from 'react';
import {
    CircularProgress,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField
} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { useSwaggerClient } from '../../../../hooks/useSwaggerClient';
import { Alert } from '@material-ui/lab';
import { formatMoney } from '../../../../utils';
import { SummaryDownIcon, SummaryUpIcon } from '../../../../icons';

function UpDownIcon({ value }) {
    if (value > 0) {
        return (
            <IconButton size="small" style={{ padding: '5px' }} disabled>
                <SummaryUpIcon />
            </IconButton>
        );
    }
    if (value < 0) {
        return (
            <IconButton size="small" style={{ padding: '5px' }} disabled>
                <SummaryDownIcon />
            </IconButton>
        );
    }
    return <IconButton size="small" style={{ padding: '5px' }} disabled></IconButton>;
}

const SummaryTable = ({ agentId }) => {
    const [dateFilter, setDateFilter] = useState(moment().format('YYYY-MM-DD'));
    const [summaryDatas, summaryDatasLoading, summaryDatasError] = useSwaggerClient(
        'users/statistics',
        'getAgentStatistics',
        {
            agentId: parseInt(agentId, 10),
            fromDate: dateFilter
        }
    );

    return (
        <Grid item xs={12} container alignContent="flex-start">
            <Grid item>
                <h2 style={{ marginBottom: '10px' }}>Summary</h2>
            </Grid>
            <Grid item xs={12}>
                <DatePicker
                    value={dateFilter}
                    onChange={newDate => {
                        setDateFilter(moment(newDate).format('YYYY-MM-DD'));
                    }}
                    disableFuture
                    renderInput={props => <TextField {...props} helperText="" />}
                />
            </Grid>
            {summaryDatasLoading ? (
                <CircularProgress />
            ) : (
                <TableContainer
                    component={Paper}
                    style={{ marginBottom: '20px', marginTop: '20px' }}
                >
                    {summaryDatasError && (
                        <TableRow>
                            <TableCell colSpan={11} style={{ textAlign: 'center' }}>
                                <Alert severity="error">
                                    <h4>
                                        {summaryDatasError.message ||
                                            summaryDatasError.response.body.message}
                                    </h4>
                                </Alert>
                            </TableCell>
                        </TableRow>
                    )}
                    <Table size="medium" style={{ backgroundColor: '#fafafa' }}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Number of Bookings</TableCell>
                                <TableCell align="center">Gross Bookings</TableCell>
                                <TableCell align="center">Total Guest</TableCell>
                                <TableCell align="center">Total Commission</TableCell>
                                <TableCell align="center">Total Voucher</TableCell>
                                <TableCell align="center">Number of Refunds</TableCell>
                                <TableCell align="center">Total Refunds</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell align="center" style={{ fontSize: '1.2rem' }}>
                                    {summaryDatas?.summaryDatas?.numberOfBookings}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '1.2rem' }}>
                                    {formatMoney(summaryDatas?.summaryDatas?.grossBookings)}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '1.2rem' }}>
                                    {summaryDatas?.summaryDatas?.totalGuests}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '1.2rem' }}>
                                    {formatMoney(summaryDatas?.summaryDatas?.totalCommission)}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '1.2rem' }}>
                                    {summaryDatas?.summaryDatas?.totalVoucher}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '1.2rem' }}>
                                    {summaryDatas?.summaryDatas?.numberOfRefunds}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '1.2rem' }}>
                                    {formatMoney(summaryDatas?.summaryDatas?.totalRefund)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="center" style={{ fontSize: '0.8rem' }}>
                                    <UpDownIcon
                                        value={
                                            summaryDatas?.calculatedSummaryDatas
                                                ?.calculatedNumberOfBookings
                                        }
                                    />
                                    {
                                        summaryDatas?.calculatedSummaryDatas
                                            ?.calculatedNumberOfBookings
                                    }
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '0.8rem' }}>
                                    <UpDownIcon
                                        value={
                                            summaryDatas?.calculatedSummaryDatas
                                                ?.calculatedGrossBookings
                                        }
                                    />
                                    {formatMoney(
                                        summaryDatas?.calculatedSummaryDatas
                                            ?.calculatedGrossBookings
                                    )}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '0.8rem' }}>
                                    <UpDownIcon
                                        value={
                                            summaryDatas?.calculatedSummaryDatas
                                                ?.calculatedTotalGuests
                                        }
                                    />
                                    {summaryDatas?.calculatedSummaryDatas?.calculatedTotalGuests}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '0.8rem' }}>
                                    <UpDownIcon
                                        value={
                                            summaryDatas?.calculatedSummaryDatas
                                                ?.calculatedTotalCommission
                                        }
                                    />
                                    {formatMoney(
                                        summaryDatas?.calculatedSummaryDatas
                                            ?.calculatedTotalCommission
                                    )}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '0.8rem' }}>
                                    <UpDownIcon
                                        value={
                                            summaryDatas?.calculatedSummaryDatas
                                                ?.calculatedTotalVoucher
                                        }
                                    />
                                    {summaryDatas?.calculatedSummaryDatas?.calculatedTotalVoucher}
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '0.8rem' }}>
                                    <UpDownIcon
                                        value={
                                            summaryDatas?.calculatedSummaryDatas
                                                ?.calculatedNumberOfRefunds
                                        }
                                    />
                                    {
                                        summaryDatas?.calculatedSummaryDatas
                                            ?.calculatedNumberOfRefunds
                                    }
                                </TableCell>
                                <TableCell align="center" style={{ fontSize: '0.8rem' }}>
                                    <UpDownIcon
                                        value={
                                            summaryDatas?.calculatedSummaryDatas
                                                ?.calculatedTotalRefund
                                        }
                                    />
                                    {formatMoney(
                                        summaryDatas?.calculatedSummaryDatas?.calculatedTotalRefund
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Grid>
    );
};

export default SummaryTable;
